/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class OperationPostureCloudData {
    getFixupPrototypeFunction() { return OperationPostureCloudData.fixupPrototype; }

    static newInstance(model: Partial<OperationPostureCloudData>): OperationPostureCloudData {
        let obj = Object.assign(new OperationPostureCloudData(), model);
        OperationPostureCloudData.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<OperationPostureCloudData>): OperationPostureCloudData {
        if (!model) return null;
        return OperationPostureCloudData.newInstance(<OperationPostureCloudData> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: OperationPostureCloudData) {
        if (!obj) return;

        models.OperationPostureCloudData.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: OperationPostureCloudData): boolean {
        Object.setPrototypeOf(obj, OperationPostureCloudData.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.alerts === undefined) {
            this.alerts = 0;
        }
        if (this.activities === undefined) {
            this.activities = 0;
        }
        if (this.automation_failures === undefined) {
            this.automation_failures = 0;
        }
    }

    /**
     * cloud account name
     */
    cloud_account_name: string;

    /**
     * cloud account id
     */
    cloud_account_id: string;

    /**
     * alerts count
     */
    alerts: number;

    /**
     * activities cost
     */
    activities: number;

    /**
     * automation count
     */
    automation_failures: number;

    /**
     * Name of the tenant
     */
    tenant_name: string;

    /**
     * cloud name
     */
    cloud: string;

}
